module.exports = __webpack_public_path__ + "static/media/channel-banner.37c41ae9.jpg";